export default {
  common: {
    clearAll: 'נקה הכל',
    restart: 'הפעל מחדש'
  },
  download: {
    bodyText: 'לחץ על קישור ההורדה למטה כדי להוריד את %{products}',
    bothProducts: 'PlayBase ו/או Nexus',
    bodyTextFromAcceptInvitation:
      'תהליך זה ייקח זמן מה. בינתיים, אתה יכול להמשיך להשתמש ב-Metrica Sports כרגיל.',
    bodyTextFromDeclineInvitation:
      '!דחית את ההזמנה. לחץ על קישור ההורדה למטה כדי להוריד את %{products}',
    bodyTextFromTrial:
      'ברוך הבא להגדרת הניסיון שלך! בדוק את הדוא"ל שנרשמת בו לקבלת קישור לאימות (בדוק בתיקיית הספאם).',
    bodyTitle: 'הורדה',
    bodyTitleFromAcceptInvitation: 'אנו מחליפים את החשבון שלך',
    bodyTitleFromDeclineInvitation: 'הזמנה נדחתה',
    bodyTitleFromTrial: 'ההרשמה הושלמה',
    play2: {
      description:
        'Metrica PlayBase היא כלי ניתוח אינטואיטיבי שתוכנן עבור מאמנים חובבים ופרוסומרים, מועדונים קטנים ואנליסטים עצמאיים. היא מפשטת את תהליך ההערכה של ביצועים, והופכת אותו לנגיש לכולם.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        'Metrica Nexus מותאם לאנליסטים ומאמנים מהשורה הראשונה המחפשים מידע מקיף על ביצועים. עם כלים מתקדמים בהישג ידך, תוכל לשפר את אסטרטגיות הקבוצה ולהביא להצלחה.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks: 'תודה שנרשמת ל-Metrica Sports! כדי להתחיל עם הניסיון שלך, הורד את %{products}.'
  },
  error: {
    restart: 'נראה שאתה מנסה להיכנס למשהו שאנחנו עדיין מפתחים...',
    tryAgainMsg: 'נסה שוב, אם שגיאה זו תמשיך, צור קשר עם צוות התמיכה של Metrica Sports'
  },
  verifyEmail: {
    generateLink: 'צור קישור חדש על ידי כניסה ל- Play',
    readyToLogin: 'אתה מוכן להתחבר ל- Play',
    successfully: 'האימייל אומת בהצלחה',
    unsuccessfully: 'שגיאה באימות דואר אלקטרוני, אסימון לא חוקי'
  }
}
